import { call, put, select, take, fork, cancel } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import { EntityTypesSelectors } from '../reducers/EntityTypesRedux'

const parsePayload = (payload) =>
  payload && (payload.data || payload.params || payload.id || payload.query)
    ? [payload.data || payload.id, payload.params || { query: payload.query }]
    : [payload, undefined]

export function* findEntities(api, entityType, actions, { payload }) {
  try {
    const typeId = yield select(EntityTypesSelectors.getIdByName(entityType))
    var [_, params] = parsePayload(payload)
    if (!params) {
      params = {}
    }
    params.query = { ...params.query, typeId }

    const response = yield call(api.find, 'entities', params)
    yield put(actions.findSuccess(response.data || response))
  } catch (err) {
    yield put(actions.findFailure(err.message))
  }
}

export function* getEntity(api, actions, { payload }) {
  try {
    const [id, params] = parsePayload(payload)

    const response = yield call(api.get, 'entities', id, params)

    yield put(actions.getSuccess(response))
  } catch (err) {
    yield put(actions.getFailure(err.message))
  }
}

export function* updateEntity(api, actions, { payload }) {
  try {
    const [data, params] = parsePayload(payload)
    for (const key in data.properties) {
      if (data.properties[key] instanceof File) {
        const file = data.properties[key]
        const contentType = file.type

        const fileData = {
          buffer: file,
          contentType: contentType,
        }
        const response = yield call(api.create, 'files', fileData)
        // Verificamos si la carga fue exitosa
        if (response?._id) {
          data.properties[key] = response._id
        } else {
          throw new Error('Error·uploading·file')
        }
      }
    }

    // Actualizamos la entidad con el nuevo fileId
    const response = yield call(api.patch, 'entities', data._id, data, params)
    yield put(actions.updateSuccess(response))
  } catch (err) {
    yield put(actions.updateFailure(err.message))
  }
}

export function* deleteEntity(api, actions, { payload }) {
  try {
    const [data, params] = parsePayload(payload)

    const response = yield call(api.remove, 'entities', data._id, params)
    yield put(actions.deleteSuccess(response))
  } catch (err) {
    yield put(actions.deleteFailure(err.message))
  }
}

export function* createEntity(api, actions, { payload }) {
  try {
    const [data, params] = parsePayload(payload)

    const response = yield call(api.create, 'entities', data, params)
    yield put(actions.createSuccess(response))
  } catch (err) {
    yield put(actions.createFailure(err.message))
  }
}

const createServiceChannel = (service) => {
  return eventChannel((emit) => {
    const createdHandler = (msg) => emit({ event: 'created', payload: msg })
    const updatedHandler = (msg) => emit({ event: 'updated', payload: msg })
    const removedHandler = (msg) => emit({ event: 'removed', payload: msg })

    service.on('created', createdHandler)
    service.on('updated', updatedHandler)
    service.on('patched', updatedHandler)
    service.on('removed', removedHandler)

    const unsubscribe = () => {
      service.off('created', createdHandler)
      service.off('updated', updatedHandler)
      service.off('patched', updatedHandler)
      service.off('removed', removedHandler)
    }

    return unsubscribe
  })
}

const watchServiceChannel = function* (api, entityType, actions) {
  const service = yield call(api.service, 'entities')
  const channel = yield call(createServiceChannel, service)
  const typeId = yield select(EntityTypesSelectors.getIdByName(entityType))

  while (true) {
    try {
      // An error from socketChannel will cause the saga jump to the catch block
      const msg = yield take(channel)
      if (msg.payload.typeId !== typeId) {
        continue
      }
      switch (msg.event) {
        case 'created':
          yield put(actions.createSuccess(msg.payload))
          break
        case 'updated':
        case 'patched':
          yield put(actions.updateSuccess(msg.payload))
          break
        case 'removed':
          yield put(actions.deleteSuccess(msg.payload))
          break
        default:
          break
      }
    } catch (err) {
      console.error('service error:', err)
    }
  }
}

const createSocketChannel = (io) => {
  return eventChannel((emit) => {
    io.on('reconnect', (params) => emit({ event: 'reconnect', params }))

    const unsubscribe = () => {}

    return unsubscribe
  })
}

const watchSocketChannel = function* (api, actions) {
  const channel = yield call(createSocketChannel, api.io)
  while (true) {
    try {
      const msg = yield take(channel)
      switch (msg.event) {
        case 'reconnect':
          yield put(actions.findRequest())
          break
        default:
          break
      }
    } catch (err) {
      console.error('service error:', err)
    }
  }
}


let serviceChannelTask;
let socketChannelTask;

export function* watchEntities(api, entityType, actions) {

  serviceChannelTask = yield fork(watchServiceChannel, api, entityType, actions)
  socketChannelTask = yield fork(watchSocketChannel, api, entityType, actions)
  
  yield call(api.register, 'entities', 'create');
  yield call(api.register, 'entities', 'patch');
  yield call(api.register, 'entities', 'update');
  yield call(api.register, 'entities', 'remove');
}

export function* unwatchEntities(api) {

  yield call(api.unregister, 'entities', 'create');
  yield call(api.unregister, 'entities', 'patch');
  yield call(api.unregister, 'entities', 'update');
  yield call(api.unregister, 'entities', 'remove');

  if (serviceChannelTask) {
    yield cancel(serviceChannelTask);
  }
  
  if (socketChannelTask) {
    yield cancel(socketChannelTask);
  }
  
  
};